import { removeCompanyFromSessionStorage } from '@sit/client-shared';
import { useInitializeIntacctMod } from '@web/services/intacct-mod';
import { useEffect } from 'react';
import styled from 'styled-components';
import { Authenticate } from './Authenticate';
import { ErrorComponent } from './Error';
import { useExternalTokenData } from './hooks/useExternalTokenData';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  // The Intacct background color.
  background-color: '#f2f5f6';
  color: ${({ theme }) => theme.colors.white};
`;

const LoadingPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space[2]};
`;

const ExternalAuth = () => {
  /**
   * This is a workaround for the issue where the user is logged in to Intacct
   * and then logs out of Intacct, but the user is still logged in to SIT.
   * Subsequent attempts to log in to Intacct with a different company
   * will result in network requests to SIT using the previous company ID.
   * @see https://jira.sage.com/browse/SIT-1825
   */
  useEffect(() => {
    void removeCompanyFromSessionStorage();
  }, []);
  useInitializeIntacctMod();
  const data = useExternalTokenData();

  if (data.isLoading) {
    return (
      <Container>
        <LoadingPlaceholder />
      </Container>
    );
  }

  if (data.isError || !data.url) {
    return (
      <Container>
        <ErrorComponent />
      </Container>
    );
  }

  return (
    <Container>
      <Authenticate target={data.url} token={data.token} />
    </Container>
  );
};

export default ExternalAuth;
